/**
 * Minimal cookie-consent store. There is no analytics/ad SDK wired in yet (Cloudflare Web
 * Analytics is cookieless and isn't gated), so this exists to (a) give visitors the
 * accept/reject control the Cookie Policy already promises, and (b) give future ad code a single
 * place to check before it runs — see hasAdConsent().
 */

export type ConsentChoice = "accepted" | "rejected";

const STORAGE_KEY = "heartopia-cookie-consent";
export const CONSENT_CHANGE_EVENT = "heartopia:consent-change";

export function getStoredConsent(): ConsentChoice | null {
  if (typeof window === "undefined") return null;
  const raw = window.localStorage.getItem(STORAGE_KEY);
  return raw === "accepted" || raw === "rejected" ? raw : null;
}

export function setStoredConsent(choice: ConsentChoice): void {
  window.localStorage.setItem(STORAGE_KEY, choice);
  window.dispatchEvent(new CustomEvent<ConsentChoice>(CONSENT_CHANGE_EVENT, { detail: choice }));
}

/** Whether non-essential (advertising/personalization) cookies may be set. Ad script loading
 * should check this before injecting the AdSense snippet for EEA/UK visitors. */
export function hasAdConsent(): boolean {
  return getStoredConsent() === "accepted";
}
